// Revival • Water landing page. The form still posts normally to Shopify; this only adds friendlier checks first.

// In-page links. This theme does not jump to #anchors on its own, so scroll here.
// Links with data-rw-interest also preselect that option in the enquiry form.
document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href^="#rw-"]');
  if (!link) return;
  var target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();

  var interest = link.getAttribute('data-rw-interest');
  var select = document.getElementById('rw-interest');
  if (interest && select) select.value = interest;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
  if (history.replaceState) history.replaceState(null, '', '#' + target.id);
});

// Inline errors plus a summary, keeping whatever the visitor typed.
document.addEventListener('submit', function (event) {
  var form = event.target.closest('.rw-form');
  if (!form) return;
  var summary = form.querySelector('[data-rw-summary]');
  var list = summary.querySelector('ul');
  var failed = [];
  list.textContent = '';

  form.querySelectorAll('[data-rw-message]').forEach(function (field) {
    var error = document.getElementById(field.id + '-error');
    var ok = field.value.trim() !== '' && field.checkValidity();
    field.setAttribute('aria-invalid', ok ? 'false' : 'true');
    error.hidden = ok;
    error.textContent = ok ? '' : field.getAttribute('data-rw-message');
    if (ok) return;
    failed.push(field);
    var item = document.createElement('li');
    var link = document.createElement('a');
    link.href = '#' + field.id;
    link.textContent = field.getAttribute('data-rw-message');
    item.appendChild(link);
    list.appendChild(item);
  });

  summary.hidden = failed.length === 0;
  if (failed.length) {
    event.preventDefault();
    summary.focus();
  }
});

// Everyday uses: tabs. Without JavaScript every panel simply shows in a list.
function rwTabs(root) {
  if (root.dataset.rwReady) return;
  root.dataset.rwReady = '1';
  var list = root.querySelector('[role="tablist"]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
  if (!list || !tabs.length) return;
  list.hidden = false;
  root.classList.add('rw-tabs--on');

  function select(i, focus) {
    tabs.forEach(function (t, j) {
      var on = i === j;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      panels[j].hidden = !on;
    });
    if (focus) tabs[i].focus();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(i, false); });
    t.addEventListener('keydown', function (e) {
      var k = e.key, n = tabs.length;
      if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); select((i + 1) % n, true); }
      if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); select((i - 1 + n) % n, true); }
      if (k === 'Home') { e.preventDefault(); select(0, true); }
      if (k === 'End') { e.preventDefault(); select(n - 1, true); }
    });
  });
  select(0, false);
}

// Quiz: one question at a time, instant feedback, score at the end. Nothing is stored or sent.
function rwQuiz(root) {
  if (root.dataset.rwReady) return;
  root.dataset.rwReady = '1';
  var qs = Array.prototype.slice.call(root.querySelectorAll('.rw-q'));
  if (!qs.length) return;
  var progress = root.querySelector('.rw-quiz-progress');
  var count = root.querySelector('[data-rw-quiz-count]');
  var bar = root.querySelector('[data-rw-quiz-bar]');
  var actions = root.querySelector('.rw-quiz-actions');
  var next = root.querySelector('[data-rw-quiz-next]');
  var result = root.querySelector('[data-rw-quiz-result]');
  var score = root.querySelector('[data-rw-quiz-score]');
  var current = 0, right = 0;
  root.classList.add('rw-quiz--on');
  progress.hidden = false;

  function show(i) {
    qs.forEach(function (q, j) { q.hidden = i !== j; });
    count.textContent = 'Question ' + (i + 1) + ' of ' + qs.length;
    bar.style.width = (i / qs.length * 100) + '%';
    actions.hidden = true;
  }
  function reset() {
    qs.forEach(function (q) {
      q.querySelectorAll('.rw-q-option').forEach(function (b) {
        b.disabled = false; b.classList.remove('is-right', 'is-wrong'); b.removeAttribute('aria-pressed');
      });
      q.querySelector('.rw-q-feedback').textContent = '';
      q.querySelector('.rw-q-explain').hidden = true;
    });
    current = 0; right = 0; result.hidden = true; progress.hidden = false; show(0);
  }

  qs.forEach(function (q) {
    var answer = q.getAttribute('data-rw-answer');
    q.querySelectorAll('.rw-q-option').forEach(function (b) {
      b.addEventListener('click', function () {
        var ok = b.getAttribute('data-rw-option') === answer;
        if (ok) right++;
        q.querySelectorAll('.rw-q-option').forEach(function (o) {
          o.disabled = true;
          if (o.getAttribute('data-rw-option') === answer) o.classList.add('is-right');
        });
        b.setAttribute('aria-pressed', 'true');
        if (!ok) b.classList.add('is-wrong');
        q.querySelector('.rw-q-feedback').textContent = ok ? 'Correct.' : 'Not quite.';
        q.querySelector('.rw-q-explain').hidden = false;
        next.innerHTML = current === qs.length - 1 ? 'See your score <span aria-hidden="true">→</span>' : 'Next question <span aria-hidden="true">→</span>';
        actions.hidden = false;
        bar.style.width = ((current + 1) / qs.length * 100) + '%';
      });
    });
  });

  next.addEventListener('click', function () {
    current++;
    if (current < qs.length) {
      show(current);
      var first = qs[current].querySelector('.rw-q-option');
      if (first) first.focus();
    } else {
      qs.forEach(function (q) { q.hidden = true; });
      actions.hidden = true; progress.hidden = true;
      score.textContent = 'You got ' + right + ' out of ' + qs.length + '.';
      result.hidden = false; result.focus();
    }
  });
  root.querySelector('[data-rw-quiz-again]').addEventListener('click', function () {
    reset();
    var first = qs[0].querySelector('.rw-q-option');
    if (first) first.focus();
  });
  show(0);
}

function rwInit() {
  document.querySelectorAll('[data-rw-tabs]').forEach(rwTabs);
  document.querySelectorAll('[data-rw-quiz]').forEach(rwQuiz);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rwInit); else rwInit();
document.addEventListener('shopify:section:load', rwInit);
